module.exports = __webpack_public_path__ + "static/media/lodgingThumb3.fed99ee4.jpg";